import { PLATFORM_ID_MAP } from '../../constants/index'
import { isNullOrUndefinedOrEmptyStr } from './base'

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * 数字保留固定位数，千分位表示
 * @param {*} num
 * @param {*} decimals
 * @returns
 */
export function commaNum(num, decimals = 0) {
  if (num === '' || num === undefined || num === null) return '-'
  const newNum = parseFloat(num)
  const minus = newNum.toFixed(decimals) < 0 ? '-' : ''
  const numList = String(Math.abs(newNum).toFixed(decimals)).split('.')
  let firstStr = ''
  while (numList[0].length > 3) {
    firstStr = ',' + numList[0].slice(-3) + firstStr
    numList[0] = numList[0].slice(0, numList[0].length - 3)
  }
  if (numList[0]) { firstStr = numList[0] + firstStr }
  if (numList.length > 1) {
    return minus + firstStr + '.' + numList[1]
  } else {
    return minus + firstStr
  }
}

export function humanizedNum(srcNum) {
  if (isNullOrUndefinedOrEmptyStr(srcNum) || Number(srcNum) === 0) {
    return '0'
  }

  // 切割
  const num = Number(srcNum)
  if (num < 1000 && num > -1000) {
    return num
  }
  const comma = commaNum(num)
  if (comma.indexOf(',') === -1) {
    // no comma
    return comma
  } else {
    // exist comma
    const unitArr = ['B', 'M', 'K']
    const commaSlited = comma.split(',')

    if (commaSlited.length <= 3) {
      return commaSlited[0] + unitArr[unitArr.length - (commaSlited.length - 1)]
    } else {
      return commaSlited.slice(0, -3).join(',') + unitArr[0]
    }
  }
}

/**
 * 根据平台的id获取平台名称
 * @param {} platformId
 * @returns
 */
export function getPlatformName(platformId) {
  const ret = Object.values(PLATFORM_ID_MAP).find(platform => platform.id === platformId)
  return ret && ret.name ? ret.name : ''
}

/**
 * 根据平台的id获取平台英文名称
 * @param {} platformId
 * @returns
 */
export function getPlatformEnglishName(platformId) {
  const ret = Object.values(PLATFORM_ID_MAP).find(platform => platform.id === platformId)
  return ret && ret.englishName ? ret.englishName : ''
}

/**
 * 根据文件名称获取文件扩展
 * @param {String} fileName
 * @returns
 */
export function getFileExt(fileName) {
  if (!fileName) {
    return ''
  }

  const matched = String(fileName).trim().match(/.+\.([^. ]*)$/)
  if (matched.length >= 2) {
    return matched[1]
  } else {
    return ''
  }
}

/**
 * 排序
 * @param {String} propertyName
 * * @param {Boolean} type
 * @returns
 */
export function compare(propertyName, type) {
  return function(object1, object2) {
    const value1 = object1[propertyName]
    const value2 = object2[propertyName]
    if (value2 < value1) {
      return type ? 1 : -1
    } else if (value2 > value1) {
      return type ? -1 : 1
    } else {
      return 0
    }
  }
}

export function toChinesNum(num) {
  const arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'] // 可继续追加更高位转换值
  if (!num || isNaN(num)) {
    return '零'
  }
  const english = num.toString().split('')
  let result = ''
  for (let i = 0; i < english.length; i++) {
    const des_i = english.length - 1 - i// 倒序排列设值
    result = arr2[i] + result
    const arr1_index = english[des_i]
    result = arr1[arr1_index] + result
  }
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十')
  result = result.replace(/零+/g, '零')
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万')
  result = result.replace(/亿万/g, '亿')
  result = result.replace(/零+$/, '')
  result = result.replace(/^一十/g, '十')

  return result
}
